import { StripeBaseData } from "./stripe-base-data";
import { StripeSubscriptionData } from "./stripe-subscription-data";

export class StripeCustomerData extends StripeBaseData{
    public balance: number;    
    public invoice_settings: any;
    public subscriptions: Array<StripeSubscriptionData>;
}